import { EmptyStatePanel } from '@playforge/ui';
import { Card, Page } from '@shopify/polaris';

/** Placeholder for sidebar sections built in later milestones. */
export function ComingSoonPage({ title }: { title: string }): JSX.Element {
  return (
    <Page title={title}>
      <Card>
        <EmptyStatePanel heading={`${title} is coming soon`}>
          <p>This section is part of an upcoming milestone.</p>
        </EmptyStatePanel>
      </Card>
    </Page>
  );
}
